export default __webpack_public_path__ + "static/media/evento-4.528f654e.jpg";